// extracted by mini-css-extract-plugin
export default {"container":"ArrowBack_container__hF-HJ"};